define('DisplayCommerceCategoryFields.EntryPoint', [
  'DisplayCommerceCategoryFields.SS2Model',
  'DisplayCommerceCategoryFields.View'
], function (
  DisplayCommerceCategoryFieldsSS2Model,
  DisplayCommerceCategoryFieldsView
) {
  'use strict';

  return{
    mountToApp: function mountToApp(container) {
      var pathName = '';
      var href = '';
      var layout = container.getComponent('Layout');
      var plp = container.getComponent('PLP');
      var self = this;
      var catDesc = '';
      var catFaq = '';

      plp.on('beforeShowContent', function () {
        var model = new DisplayCommerceCategoryFieldsSS2Model();
        var categoryinfo = plp.getCategoryInfo();
        catDesc = '';
        catFaq = '';
        self.catDesc = '';
        self.catFaq = '';
        self.urlFragment = '';

        if (categoryinfo) {
          var categoryId = categoryinfo.internalid;

          if (categoryId) {
            return model.fetch({
              data: {
                categoryId: categoryId
              }
            }).done(function (result) {
              if(result && result.success && result.value.length > 0) {
                self.urlFragment = result.value[0].urlfragment;
                self.catDesc = result.value[0].catdesc;
                self.catFaq = result.value[0].catfaq;
              }
            }).then(function () {
              pathName = window && window.location && window.location.pathname || '';
              href = window && window.location && window.location.href || '';
              if (self.catDesc && self.catFaq && pathName.endsWith(self.urlFragment) && href.indexOf('page=') === -1) {
                catDesc = self.catDesc;
                catFaq = self.catFaq;
              }else{
                catDesc = '';
                catFaq = '';
              }
            });

          }
        }
      });

      layout.addChildView('Top.Desc.View', function () {
        return new DisplayCommerceCategoryFieldsView({
          catDesc: catDesc,
          urlFragment: self.urlFragment
        });
      });

      layout.addChildView('Bottom.Faq.View', function () {
        return new DisplayCommerceCategoryFieldsView({
          catFaq: catFaq,
          urlFragment: self.urlFragment
        });
      });
    }
  };
});
